// extracted by mini-css-extract-plugin
export default {"nav":"header_nav__AAxCX","brand":"header_brand__kYTZC","logo":"header_logo__3b7J5"};